<template>
  <div>
    <section id="page-title">
      <div class="bg-header"></div>
      <div class="container clearfix">

      </div>
    </section>
    <div class="container" id="element">
        <div class="list-group mb-3" v-if="servico.length">
            <div class="list-group-item list-group-item-action active">
                <h4 class="mb-0" style="color:#fff">Serviço: {{servico.titulo}}</h4>
            </div>
        </div>
        
      <div class="row">
        <div class="col-sm-6" v-show="!continuar">
          <div class="card mb-0">
            <form style="padding:15px;">
              <h4>Já tem cadastro? Faça seu login</h4>
              <div class="form-group">
                <label for="login">Login</label>
                <input type="text" class="form-control" id="login" v-model="user.login" required placeholder="Digite o login" />
              </div>
              <div class="form-group">
                <label for="senha">Senha</label>
                <input type="password" class="form-control" id="senha" v-model="user.senha" required placeholder="Senha" />
              </div>
              <button type="submit" @click="fnSingIn" class="btn btn-primary mt-3">Entrar</button>
            </form>
          </div>
        </div>
        <div class="col-sm-6" :class="{ 'col-sm-8 offset-sm-2': continuar }">
          <div class="card mb-0">
            <form style="padding:15px;" @submit="fnCadastra">
              <h4>Inciar cadastro</h4>
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label for="_formCadastro">CNPJ</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="cadastro.cnpj"
                    id="_formCadastro"
                    placeholder="CNPJ"
                    required
                    maxlength="14"
                    @change="validaCnpj"
                    v-mask="'##############'"

                  />
                </div>
                <div class="form-group col-md-6">
                  <label for="_login">Login</label>
                  <input
                    type="text"
                    class="form-control"
                    maxlength="50"
                    v-model="cadastro.login"
                    id="_login"
                    placeholder="Login"
                    required
                  />
                </div>

                <div class="col-sm-3  ml-auto text-right">
                     <button
                    type="button"
                    v-show="!continuar"
                    @click="fnContinuar"
                    class="btn btn-primary"
                >Continuar</button>
                </div>
              </div>

              <div v-show="continuar">
                <div class="form-group">
                  <label for="_email">Email</label>
                  <input
                    type="email"
                    class="form-control"
                    id="_email"
                    placeholder
                    required
                    v-model="cadastro.email"
                    maxlength="100"
                  />
                </div>
                <div class="form-row">
                 <div class="form-group col-md-12">
                  <label for="_nomeEmpresa">Nome da empresa</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="cadastro.NomeEmpresa"
                    id="_nomeEmpresa"
                    placeholder="Nome da empresa"
                    required
                    maxlength="100"
                  />
                </div>

                <div class="form-group col-md-6">
                  <label for="_senha">Senha</label>
                  <input
                    type="password"
                    class="form-control"
                    required
                    v-model="cadastro.senha"
                    id="_senha"
                    placeholder="Senha"
                  />
                </div>
                <div class="form-group col-md-6">
                  <label for="_confirmesenha">Confirme a senha</label>
                  <input
                    type="password"
                    class="form-control"
                    id="_confirmesenha"
                    placeholder="Confirme a senha"
                    v-model="confirmeSenha"
                    required
                  />
                </div>                   
                  <div class="form-group col-sm-6">
                    <label for="_telefone">Telefone</label>
                    <input
                      type="tel"
                      class="form-control"
                      id="_telefone"
                      placeholder="Telefone"
                      required
                      v-model="cadastro.TelefoneFixo"
                      maxlength="11"
                    />
                  </div>
                  <div class="form-group col-sm-6">
                    <label for="_funcionarios">Número de funcionários</label>
                    <input
                      type="number"
                      class="form-control"
                      id="_funcionarios"
                      placeholder="Número de funcionários"
                      required
                      v-model="cadastro.NumeroFuncionario"
                    />
                  </div>
                </div>
                <button type="submit" class="btn btn-primary">Fazer cadastro</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import {getSuccess, formatPrice, validarCNPJ } from "../global/utils";

export default {
  data() {
    return {
      cadastro: {},
      servico: {},
      user: {
          login: '',
          senha: '',
      },
      confirmeSenha: "",
      continuar: false,
      contratar: true,
      temServico: this.$route.params.idServico,
    };
  },
computed: mapState(['client']),

  mounted() {
    this.fnCarregaItems();
  },

  methods: {
    precoFormato(value){
       return formatPrice(value);
    }, validaCnpj(){
      var cpfValido = validarCNPJ(this.cadastro.cnpj);
      if(!cpfValido){
         this.$toasted.global.defaultInfo({
            msg: "CNPJ inválido",
          });
          this.cadastro.cnpj = null;
      }
    },
    async fnContinuar() {

      if (
        this.cadastro.login != '' && this.cadastro.login != undefined &&
        this.cadastro.cnpj != '' && this.cadastro.cnpj != undefined
      ) {

     await this.$http
        .get("clientes/validacao/"+this.cadastro.cnpj+"/"+this.cadastro.login)
        .then(() => {
         this.continuar = true;
        })
        .catch(() => {});
      } else {
        this.$toasted.global.defaultError({ msg: "Preencha os campos de CNPJ e Login!" });
      }
    },
    async fnCadastra(e) {
      e.preventDefault();
      if (this.cadastro.senha == this.confirmeSenha)
      {
        this.cadastro.tsInclusao = this.$moment().format();
        await this.$http
            .post("clientes/cadastro", this.cadastro)
            .then((res) => {
              console.log(res.data);
                this.$store.commit("setClient",res.data)
               var destino = this.$route.params.idServico ? '/areacliente/' + this.$route.params.idServico + '/contratar/' : '/areacliente'
               window.location.href = destino
                getSuccess();
            })
            .catch(() => {});
        }else{
            this.$toasted.global.defaultError({ msg: "Senhas não conferem!" });
        }
    },
    async fnCarregaItems() {
      if(this.$route.params.idServico != undefined)
      {
      await this.$http
        .get("servicos/api/" + this.$route.params.idServico)
        .then((res) => {
          this.servico = res.data;
        })
        .catch(() => {});

      }
    },
    async fnSingIn(e){
      e.preventDefault();
        if (this.user.login !='' && this.user.senha != ''){
            await this.$http.post("clientes/auth",this.user)
            .then(res => {
              console.log(res.data)
                    this.$store.commit("setClient",res.data)
                    var destino = this.$route.params.idServico ? '/areacliente/' + this.$route.params.idServico + '/contratar/' : '/areacliente'
                   window.location.href = destino
                })
            .catch(()=>{})

        }else{
            this.$toasted.global.defaultError({ msg: "Preencha os campos corretamentes!" });
        }
    }  

  },
};
</script>

<style lang="scss" scoped>
    #page-title{
        margin-bottom: 45px;
        padding-top: 0 !important;
        padding-bottom: 0;
    }
    .bg-header{
              background-image: url("/img/cabecalho_autoespecialistas.jpeg");
        background-size: 100%;
        height: 130px;;


    }
</style>
